import React from "react";
import { Button, SelectableOptionGroup } from "../../../common";
import * as style from "../styles.module.scss";

const WorkingWeekOptOut = ({
  handleSubmit,
  handleBack,
  state,
  handleChange,
  options,
}) => {
  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleSubmit}
    >
      <div className={`mb-4`}>
        <p className="mb-2">
          Do you wish to opt out of the 48 hour per week limit under the Working
          Time Regulations 1998, so that, if you wish, you may work in excess of
          this? You can opt back in or out at any time.
        </p>
        <p className="mb-2">You MUST be over the age of 18 to opt out.</p>
        <SelectableOptionGroup
          selectedOption={state.wtr48HrWaiver}
          handleOptionChange={(e) => {
            handleChange("wtr48HrWaiver", e.target.value);
          }}
          options={options}
          name="optOut"
        />
      </div>

      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Button
          classes="btn btn-outline-info text-dark mr-1"
          onClick={handleBack}
        >
          Back
        </Button>
        <Button classes="btn btn-primary btn-block">Next</Button>
      </div>
    </form>
  );
};

export default WorkingWeekOptOut;
